import { ReactComponent as AppleLogo } from "../assets/icons/sso/apple-logo.svg";
import { ReactComponent as FobizzLogo } from "../assets/icons/sso/fobizz-logo.svg";
import { ReactComponent as GoogleLogo } from "../assets/icons/sso/google-logo.svg";
import type { SsoProvider } from "../constants/SsoConstants";

interface SsoButtonProps {
    provider: SsoProvider;
    /** One of the provider-approved labels ("Continue with Google/Apple/fobizz"), localised. */
    label: string;
    onClick: () => void;
    disabled?: boolean;
    "data-testid"?: string;
}

const PROVIDER_LOGOS: Record<SsoProvider, typeof AppleLogo> = {
    google: GoogleLogo,
    apple: AppleLogo,
    fobizz: FobizzLogo,
};

// Apple only allows pure black or white for its logo and text. The white style, grey outline and left-pinned logo
// match the website's sign-in buttons.
const PROVIDER_TEXT_CLASSES: Record<SsoProvider, string> = {
    google: "text-google-text",
    apple: "text-apple-black",
    fobizz: "text-fobizz-text",
};

/** Sign-in button for a third-party account provider (Google, Apple, fobizz). */
const SsoButton = (props: SsoButtonProps) => {
    const Logo = PROVIDER_LOGOS[props.provider];

    return (
        <button
            type="button"
            data-testid={props["data-testid"]}
            onClick={props.onClick}
            disabled={props.disabled}
            // px-xxl keeps the centred label clear of the logo pinned to the left edge.
            className={`relative flex items-center justify-center w-full rounded-button border border-sso-border bg-white px-xxl py-xs text-m font-semibold transition-colors duration-200 ease-in-out cursor-pointer enabled:hover:bg-stone-200 disabled:opacity-50 disabled:cursor-not-allowed ${
                PROVIDER_TEXT_CLASSES[props.provider]
            }`}
        >
            <span className="absolute inset-y-no left-s flex items-center">
                <Logo
                    aria-hidden="true"
                    className="h-[20px] w-auto"
                />
            </span>
            <span>{props.label}</span>
        </button>
    );
};

export default SsoButton;
